import {
  GridList,
  GridListTile,
  GridListTileBar,
  IconButton,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { MediaGridData, MediaGridItemData } from '../../../Content';
import React, { useCallback, useState } from 'react';

import ContentPopup from '../content_popup/ContentPopup';
import { useScene } from '../../../contexts/SceneContext';

interface MediaGridContentProps {
  content: MediaGridData;
}

export const MediaGridContent: React.FC<MediaGridContentProps> = ({
  content,
}) => {
  const { parseContentPath } = useScene();

  const [activeItem, setActiveItem] = useState<MediaGridItemData | null>(null);

  const theme = useTheme();
  const BP_SM = useMediaQuery(theme.breakpoints.up('sm'));
  const BP_MD = useMediaQuery(theme.breakpoints.up('md'));

  const createMediaGrid = useCallback(() => {
    return (
      <GridList
        cellHeight={(BP_MD ? 220 : 160) * (content.items.length <= 3 ? 1.5 : 1)}
        cols={BP_SM ? Math.min(content.items.length, 3) : 1}
        spacing={10}
      >
        {content.items.map((item, index) => (
          <GridListTile key={item.title} cols={1}>
            <img
              src={item.thumbnail && parseContentPath(item.thumbnail)}
              alt={item.title}
              onClick={() => setActiveItem(item)}
              style={{ cursor: 'pointer' }}
            />
            <GridListTileBar
              title={item.title}
              actionIcon={
                <IconButton onClick={() => setActiveItem(item)}>
                  <img
                    src={item.icon && `assets/icons/${item.icon}.svg`}
                    alt={'Missing Icon'}
                    style={{ color: 'white', width: '24px', height: '24px' }}
                  />
                </IconButton>
              }
            />
          </GridListTile>
        ))}
      </GridList>
    );
  }, [content.items, setActiveItem, parseContentPath, BP_SM, BP_MD]);

  const createItemPopup = useCallback(() => {
    return (
      activeItem && (
        <ContentPopup
          content={activeItem.content}
          closeBtnText="Back"
          onCloseRequested={() => setActiveItem(null)}
        />
      )
    );
  }, [activeItem, setActiveItem]);

  return (
    <div>
      {createMediaGrid()}
      {createItemPopup()}
    </div>
  );
};
